import { useEffect, useState } from 'react';
import { API_BASE } from './config';
import { apiJson } from '../utils/apiFetch';
import { PLAY_INTENSITY_OPTIONS } from '../utils/playIntensity';
import '../css/AdminPlayerEditModal.css';

const RANKS = ['BG', 'BGM', 'NB', 'NB+', 'N-', 'N', 'N/S', 'S', 'S/P'];

export default function AdminPlayerEditModal() {
  const [player, setPlayer] = useState(null);
  const [form, setForm] = useState({ name: '', level_rank: 'BG', play_intensity: 'ANY' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const open = event => {
      let storedUser = null;
      try { storedUser = JSON.parse(localStorage.getItem('user') || 'null'); } catch {}
      if (String(storedUser?.role || '').toLowerCase() !== 'admin') return;
      const next = event.detail || {};
      if (!Number(next.user_id ?? next.userId)) return;
      setPlayer(next);
      setForm({
        name: String(next.name || ''),
        level_rank: String(next.level_rank || next.rank || 'BG').toUpperCase(),
        play_intensity: String(next.play_intensity || 'ANY').toUpperCase()
      });
      setError('');
    };
    window.addEventListener('admin-edit-player', open);
    return () => window.removeEventListener('admin-edit-player', open);
  }, []);

  if (!player) return null;
  const userId = Number(player.user_id ?? player.userId);
  const token = localStorage.getItem('token');
  const request = (path, body) => apiJson(`${API_BASE}${path}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body)
  });

  const save = async event => {
    event.preventDefault();
    setBusy(true); setError('');
    try {
      await request(`/api/admin/users/${userId}/profile`, { ...form, name: form.name.trim() });
      window.dispatchEvent(new CustomEvent('admin-player-updated', { detail: { ...player, ...form, user_id: userId } }));
      setPlayer(null);
    } catch (saveError) {
      setError(saveError.message || 'บันทึกไม่สำเร็จ');
    } finally { setBusy(false); }
  };

  return <div className="admin-player-edit-backdrop" role="presentation" onMouseDown={()=>!busy&&setPlayer(null)}>
    <form className="admin-player-edit-modal" onSubmit={save} onMouseDown={event=>event.stopPropagation()} role="dialog" aria-modal="true">
      <header><div><small>แก้ไขผู้เล่น #{userId}</small><strong>{player.name}</strong></div><button type="button" disabled={busy} onClick={()=>setPlayer(null)}>×</button></header>
      <label>ชื่อผู้เล่น<input value={form.name} minLength="2" maxLength="100" required onChange={event=>setForm(current=>({...current,name:event.target.value}))}/></label>
      <label>ระดับมือ<select value={form.level_rank} onChange={event=>setForm(current=>({...current,level_rank:event.target.value}))}>{RANKS.map(rank=><option key={rank}>{rank}</option>)}</select></label>
      <fieldset><legend>ระดับความหนัก</legend><div>{PLAY_INTENSITY_OPTIONS.map(option=><button type="button" key={option.value} className={form.play_intensity===option.value?'active':''} onClick={()=>setForm(current=>({...current,play_intensity:option.value}))}><span>{option.icon}</span><b>{option.label}</b></button>)}</div></fieldset>
      {error&&<p>{error}</p>}
      <footer><button type="button" disabled={busy} onClick={()=>setPlayer(null)}>ยกเลิก</button><button type="submit" disabled={busy}>{busy?'กำลังบันทึก…':'บันทึกข้อมูล'}</button></footer>
    </form>
  </div>;
}
